import { Link, navigate } from 'gatsby'
import React, { useEffect, useState } from 'react'
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const SupranNavBar3 = (props: RealEstateDataPageComponentData) => {
  const { global_data, button } = props

  const logo = global_data.logo
  const logoMobile = global_data.logoMobile

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return isMounted ? (
    <header
      id="header"
      className="dynamic-header c"
    >
      <Navbar className="navbar-sticky py-0">
        <Container
          fluid
          className="mx-lg-3"
          style={{ maxWidth: '100%', height: '100%' }}
        >
          <Row className="w-100 d-flex">
            <Col
              lg={4}
              xs={8}
              className="justify-content-lg-start justify-content-center px-lg-5 px-0"
            >
              <Link
                aria-label="Enlace inicio"
                className="d-flex align-items-center m-0"
                to="/"
              >
                <img
                  alt="logo-header"
                  src={logo}
                  height={'auto'}
                  width={'100%'}
                  className="d-lg-inline-block d-none align-top"
                />
              </Link>
            </Col>
            <Col
              xs={8}
              className="px-0 h-100 d-flex justify-content-center align-items-center d-xl-none d-block"
            >
              <Link
                aria-label="Enlace inicio"
                className="d-xl-block d-flex align-items-center m-0"
                to="/"
              >
                <img
                  alt="logo-header-mobile"
                  src={logoMobile}
                  style={{
                    maxHeight: '60px',
                    maxWidth: '100%',
                  }}
                  className="align-top"
                />
              </Link>
            </Col>
            <Col
              lg={8}
              xs={4}
              className="d-flex links-column pe-lg-5 pe-0"
              style={{ alignSelf: 'center', justifyContent: 'flex-end' }}
            >
              <Nav>
                <Nav.Item className="d-flex align-items-center">
                  <div
                    className="favourites-button btn"
                    onClick={() => {
                      navigate(button?.link ?? '/')
                    }}
                  >
                    <span className="favourites-text p-0 d-none d-lg-block">
                      {button?.value ?? ''}
                    </span>

                    <span className="favourites-text p-0 d-lg-none">Volver</span>
                  </div>
                </Nav.Item>
              </Nav>
            </Col>
          </Row>
        </Container>
      </Navbar>
    </header>
  ) : (
    ''
  )
}

export default SupranNavBar3
